import SelectStyled from "@/components/SelectStyled";
import { MenuItem } from "@mui/material";

export const DevelopmentProgramSortSelector = ({ setSort }) => {
  return (
    <SelectStyled
      fullWidth
      label="Sortieren nach"
      placeholder="Zuletzt hinzugefügt"
      inputProps={{ "aria-label": "Art der Förderung" }}
      onChange={setSort}
      renderValue={(selectedValue) => {
        switch (selectedValue) {
          case "created_at:desc":
            return "Zuletzt hinzugefügt";
          case "title:asc":
            return "Alphabetisch";
          case "deadline:asc":
            return "Antragsfrist";
          default:
            return "Zuletzt hinzugefügt";
        }
      }}
    >
      <MenuItem value={"created_at:desc"}>Zuletzt hinzugefügt</MenuItem>
      <MenuItem value={"title:asc"}>Alphabetisch</MenuItem>
      <MenuItem value={"deadline:asc"}>Antragsfrist</MenuItem>
    </SelectStyled>
  );
};
